import { render, staticRenderFns } from "./XAccordion.vue?vue&type=template&id=718503d0&scoped=true"
import script from "./XAccordion.vue?vue&type=script&lang=js"
export * from "./XAccordion.vue?vue&type=script&lang=js"
import style0 from "./XAccordion.vue?vue&type=style&index=0&id=718503d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718503d0",
  null
  
)

export default component.exports